// Core Modules
import React, { Component } from 'react';
// Components
import Sidebar from '../../components/Sidebar/Sidebar';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
// Styles
import '../assets/css/material-dashboard.css';
// Depandancy Modules
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import swal from 'sweetalert';

class Results extends Component {
    
    state = { 
        rows: null
    }

    componentDidMount = () => {
        if (!!document.getElementsByClassName('nav-open')[0]) {
            document.getElementsByClassName('nav-open')[0].classList.remove('nav-open');
        }
        let cUid = firebase.auth().currentUser.uid;
        firebase.database().ref(`/students/${cUid}/marks`).once('value').then((snapshot) => {
            if(!!snapshot.val()) {
                this.setState({rows: snapshot.val()});
            } else {
                this.setState({rows: 'empty'});
            }
        }).catch(e => swal("", e.message, "error"));
    }
    
    render() { 
        return ( 
            <div className="wrapper ">
                <Sidebar />
                <div className="main-panel">
                    <Navbar />
                    <div className="content">
                        <div className="container-fluid">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Exam</th>
                                        <th>Mark</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.rows === 'empty' ?
                                            <tr>
                                                <td colSpan="3" style={{textAlign: 'center'}}>
                                                    No Exams Yet
                                                </td>
                                            </tr>
                                        : !!this.state.rows ? 
                                            Object.values(this.state.rows).map((el, ind) => {
                                                return  <tr key={`resRow${ind}`}>
                                                            <td>{el.exam}</td>
                                                            <td>{el.mark}</td>
                                                            <td>{el.total}</td>
                                                        </tr>
                                            })
                                        : null
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}
 
export default Results;